<app-profile-confirm-modal [toDo]="'confirm'" *ngIf="confirmModal && route ==='/my-insurance/link-policy'" [from]="'add-policy'"></app-profile-confirm-modal>


<form 
  name="addPolicyForm"
  [formGroup]="addPolicyForm" 
  (ngSubmit)="addPolicyForm.valid && addPolicy()">
  <div class="">
    <div *ngFor="let input of inputs" class="input">
      <mapfre-validation 
        [input]="input"
        [form]="addPolicyForm"
        [maximumLength]="'6'"
      ></mapfre-validation>
    </div>
  </div>
  <div class="margin-bottom mb24 padding-left pl16">
    <input class="" type="checkbox" id="legal-checkbox" required (change)="getLegalCheckBoxValue($event)">
    <label class="disclaimer font-size legal small small-btn" [ngClass]="{'small-font brand-lite-blue ': !isAcmic,'font-color':isAcmic, 'lable-text-for-signup': !isAcmic && signupAddPolicy}" for="legal-checkbox">{{ 'I_AM_THE_POLICY_HOLDER' | translate }}</label>
  </div>
  <div class="row">
    <div class="col text-center">
      <mapfre-button [ngClass]="{'custom_loader':loader}"
        [additionalClasses]="'basic primary large-btn'"
        [disabledValue]="addPolicyForm.valid && legalCheckbox && !loader" 
        [inputType]="'submit'"
        [translateValue]="buttonLabel | translate"
        >{{buttonLabel}}</mapfre-button>
    </div>
  </div>
</form>

<ng-container *ngIf="route === '/my-insurance/link-policy'">
  <div class="row text-center margin-top mt24">
    <div class="col">
      <ng-container *ngIf="isAcmic; else maCancelBtn">
        <mapfre-button
        additionalClasses="link-button small blue-link"
        [iconClasses]="'align-middle'"
        (click)="onCheckDirty()"
      >  {{ 'CANCEL' | translate }}
      </mapfre-button>
      </ng-container>
      <ng-template #maCancelBtn>
        <mapfre-button
        additionalClasses="btn mapfre link-button large-btn red-link red-btn h40"
        [iconClasses]="'align-middle'"
        (click)="onCheckDirty()"
      >  {{ 'CANCEL' | translate }}
      </mapfre-button>
      </ng-template>      
    </div>
  </div>
</ng-container>